import React from 'react'
import { Box } from '@mui/material'
import Image from 'next/image'

import loginBannerGiftImg from '@/src/assets/png/loginBannerGift.png'

/** Visible gift area in the banner (asset has large margins; scale crops via overflow) */
export const LOGIN_BANNER_GIFT_WIDTH = 97
export const LOGIN_BANNER_GIFT_HEIGHT = 83

const GIFT_ZOOM = 1.5

interface LoginBannerGiftProps {
    width?: number
    height?: number
}

const LoginBannerGift: React.FC<LoginBannerGiftProps> = ({
    width = LOGIN_BANNER_GIFT_WIDTH,
    height = LOGIN_BANNER_GIFT_HEIGHT
}) => (
    <Box
        sx={{
            width,
            height,
            flexShrink: 0,
            overflow: 'hidden',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}
    >
        <Image
            src={loginBannerGiftImg}
            alt=""
            width={width}
            height={height}
            aria-hidden
            priority
            style={{
                display: 'block',
                objectFit: 'contain',
                transform: `scale(${GIFT_ZOOM})`,
                transformOrigin: 'center center'
            }}
        />
    </Box>
)

export { LoginBannerGift }
export type { LoginBannerGiftProps }
export default LoginBannerGift
